// extracted by mini-css-extract-plugin
export default {"form":"styles_form__H3fT2","container":"styles_container__7RJRT","buttonWrapper":"styles_buttonWrapper__1rALs"};